import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Polyline, Polygon, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import LosGraph from './Los_Graph';
import '../../styles/stile.css'
import L from 'leaflet';
import { useDataContext } from "../../context/DataContext";


const LegendControl = () => {
  const [legendAdded, setLegendAdded] = useState(false);
  const map = useMap();

  useEffect(() => {
    if (!legendAdded) {
      const legend = L.control({ position: 'bottomright' });

      legend.onAdd = function (map) {
        const div = L.DomUtil.create('div', 'mapLegend');
        div.innerHTML = `
          <div style="    background-color: #eeeeeeb0;
          padding: 0px 10px 10px;
          border: 1px solid #80808042; ">
            <div style="margin-bottom: 10px;">
              <p style="letter-spacing: normal; margin-bottom: 5px; font-size: 15px; font-family: 'Montserrat', sans-serif; color: black;">Coda Max:</p>
              <div style="background-color: #EC1D23; width: 30px; height: 5px;"></div>
            </div>
            <div>
              <p style=" letter-spacing: normal; margin-bottom: 5px; font-size: 15px; font-family: 'Montserrat', sans-serif; color: black;">Coda Media:</p>
              <div style="background-color: #FDB64E; width: 30px; height: 5px;"></div>
            </div>
          </div>
        `;

        return div;
      };

      legend.addTo(map);
      setLegendAdded(true);
    }
  }, [legendAdded, map]);

  return null;
};

const SimpleMap = ({ selectedIdScenario }) => {

  const [dataJson, setDataJson] = useState({});
  const [selectedId, setSelectedId] = useState(null);

  // Use DataContext for client-specific data (default or lavagna)
  const { dataJson: contextDataJson, dataLoaded } = useDataContext();

  useEffect(() => {
    if (dataLoaded && contextDataJson && selectedIdScenario) {
      const selectedScenario = contextDataJson.scenario?.find(scenario => scenario.replicaAvg === selectedIdScenario);
      if (selectedScenario) {
        setDataJson(selectedScenario);
        console.log('Map updated with scenario:', selectedScenario.center);
      } else {
        setDataJson({});
      }
    }
  }, [selectedIdScenario, contextDataJson, dataLoaded]);

  const handleNodeSelection = (index) => {
    const node = dataJson.nodiAimsun[index];
    if (node) {
      setSelectedId(node.id);
    } else {
      setSelectedId(null);
    }
  };


  const optionsOSM = { color: '#A3B2C9' }
  const optionCodaMax = { color: '#EC1D23' }
  const optionsCodaMedia = { color: '#FDB64E' }
  // const greenOptions = { color: '#8FC975' }
  const optionsFer = {
    color: '#470d16b3',
    dashArray: '2, 10'
  }
  const pin = '/traffic.png';

  const pinMB = L.icon({
    iconUrl: pin,
    iconSize: [22, 22],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });



  if (!dataJson || !dataJson.center) {
    return null;
  }
  return (
    <div className="container-all" >
      <div className="map-container">


        <MapContainer key={`map-${dataJson.center[1]}-${dataJson.center[0]}`} center={[dataJson.center[1], dataJson.center[0]]} zoom={17} style={{ height: "100%", width: "100%" }} preferCanvas={true} zoomSnap={0} zoomDelta={0.5} wheelDebounceTime={0} wheelPxPerZoomLevel={120} zoomAnimation={false}>
          <TileLayer
            url={`https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png?key=${process.env.REACT_APP_CARTO_KEY}`}
            detectRetina={false}
            maxNativeZoom={50}
            maxZoom={50}
            minZoom={0}
            noWrap={false}
            opacity={1}
            subdomains="abc"
            tms={false}
          />
          <LegendControl />
          {dataJson.nodiAimsun && dataJson.nodiAimsun.map((item, index) => (
            <Polygon
              eventHandlers={{
                click: () => handleNodeSelection(index),

              }}
              key={item.id}
              
              pathOptions={{
                color: selectedId === item.id ? '#1A4C3A' : '#8FC975',
              }}              positions={item.geometryNodi.coordinates}
            />
          ))}

          {selectedId && dataJson.nodiAimsun && dataJson.nodiAimsun.map(node => {
            if (node.id === selectedId && node.positionMarker && node.positionMarker.length === 2) {
              const markerPos = node.positionMarker;
              if (markerPos) {
                const parsed = [markerPos[0], markerPos[1]];
                return <Marker           
                key={`marker-${node.id}`}
                position={parsed} 
                icon={pinMB} />;
              }
            }
            return null;
          })}

          {dataJson.geometryOSM && dataJson.geometryOSM.length > 0 && dataJson.geometryOSM.filter(item => {
            const coords = item?.geometry || item;
            return Array.isArray(coords) && coords.length > 0;
          }).map((item, index) => {
            const coords = item?.geometry || item;
            return <Polyline key={`osm-${item?.id || index}`} pathOptions={optionsOSM} positions={coords} />;
          })}
          {dataJson && dataJson.nodiAimsun && dataJson.nodiAimsun.map(node => {
            if (node.id === selectedId) {
              const geometryCodaMax = node.codePerNodo[0]?.codeMax?.geometryCodaMax;
              if (geometryCodaMax) {
                const parsedCoordinates = geometryCodaMax.map(coordinates => coordinates.map(coordinate => [coordinate[0], coordinate[1]]));
                return <Polyline key={`coda-max-${node.id}`} pathOptions={optionCodaMax} positions={parsedCoordinates} />;
              }
            }
            return null;
          })}

          {selectedId && dataJson && dataJson.nodiAimsun && dataJson.nodiAimsun.map(node => (
            node.id === selectedId && node.codePerNodo[1]?.codeMedie && node.codePerNodo[1]?.codeMedie.geometryCodaMedia &&
            node.codePerNodo[1]?.codeMedie.geometryCodaMedia.map((coordinates, index) => (
              <Polyline
                key={`coda-media-${node.id}-${index}`}
                pathOptions={optionsCodaMedia}
                positions={coordinates}
              />
            ))
          ))}

        </MapContainer></div>
      <div className="los-container">
        {selectedId && <LosGraph nodeId={selectedId} selectedScenarioLos={selectedIdScenario} data={dataJson} style={{ height: "100%", width: "100%" }} />}
      </div>

    </div>
  )
}

export default SimpleMap;



